// src/components/WhatsAppButton.jsx
import React from "react";
import "../assets/css/home.css";

export default function WhatsAppButton() {
    const salesPersonNumber = localStorage.getItem("salesPersonWA") || "910000000000"; 
    //console.log("salesPersonNumber", salesPersonNumber)

    if (!salesPersonNumber) return null;

    return (
        <a
            href={`https://wa.me/${salesPersonNumber}`}
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-icon"
        >
            <i className="bx bxl-whatsapp"></i>
        </a>
    );
}
